import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import TrainingShell from '../../components/capacitacion/TrainingShell';
import ModuleCard from '../../components/capacitacion/ModuleCard';
import { trainingApi } from '../../services/trainingApi';
import { useTrainingUser } from '../../hooks/useTrainingUser';

export default function TrainingModulos() {
  const { user, isLoading: userLoading } = useTrainingUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!userLoading && !user) navigate('/capacitacion', { replace: true });
  }, [userLoading, user, navigate]);

  const { data, isLoading, error } = useQuery({
    queryKey: ['training-progress', user?.id],
    queryFn: () => trainingApi.getProgress(user!.id),
    enabled: !!user?.id,
  });

  if (!user) return null;

  const progresoAplicable = data?.progreso?.filter((p) => p.aplicable_al_rol) ?? [];
  const progresoNoAplicable = data?.progreso?.filter((p) => !p.aplicable_al_rol) ?? [];

  const aprobados = progresoAplicable.filter((p) => p.status === 'aprobado').length;
  const total = progresoAplicable.length;

  return (
    <TrainingShell>
      <div className="mb-8">
        <h1 className="text-2xl font-bold mb-2">Módulos de capacitación</h1>
        <p className="text-gray-400">
          Tu rol: <span className="text-ngs-cyan font-semibold">{user.rol}</span> ·{' '}
          Progreso: <span className="text-white">{aprobados} / {total}</span> aprobados
        </p>
        <div className="mt-3 h-2 w-full bg-ngs-surface rounded-full overflow-hidden">
          <div
            className="h-full bg-gradient-to-r from-ngs-cyan to-ngs-orange transition-all"
            style={{ width: total > 0 ? `${(aprobados / total) * 100}%` : '0%' }}
          />
        </div>
      </div>

      {isLoading && <p className="text-gray-400">Cargando módulos...</p>}
      {error ? (
        <div className="rounded-md border border-red-500/40 bg-red-500/10 text-red-300 p-4">
          Error al cargar módulos
        </div>
      ) : null}

      {data && (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {progresoAplicable.map((p) => (
              <ModuleCard
                key={p.modulo.id}
                progress={p}
                onClick={() => navigate(`/capacitacion/modulo/${p.modulo.slug}`)}
              />
            ))}
          </div>

          {progresoNoAplicable.length > 0 && (
            <div className="mt-10">
              <h2 className="text-sm uppercase tracking-wider text-gray-500 mb-3">
                Módulos que no aplican a tu rol
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {progresoNoAplicable.map((p) => (
                  <ModuleCard key={p.modulo.id} progress={p} />
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </TrainingShell>
  );
}
